'use client';

import React, { useState } from 'react';
import { toast } from 'sonner';
import Icon from '@/components/ui/AppIcon';

interface DemoCredentialsProps {
  onAutofill: (email: string, password: string) => void;
}

const DEMO_EMAIL = 'arjun.sharma@student.edu';
const DEMO_PASSWORD = 'ExamReady@2026';

export default function DemoCredentials({ onAutofill }: DemoCredentialsProps) {
  const [copiedField, setCopiedField] = useState<string | null>(null);

  const handleCopy = (value: string, field: string) => {
    navigator.clipboard.writeText(value);
    setCopiedField(field);
    toast.success(`${field} copied to clipboard`);
    setTimeout(() => setCopiedField(null), 2000);
  };

  return (
    <div
      className="rounded-xl p-4 space-y-3"
      style={{ backgroundColor: 'var(--secondary)', border: '1px solid var(--border)' }}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="text-xs font-semibold uppercase tracking-wider" style={{ color: 'var(--muted-foreground)' }}>
            Demo Account
          </span>
          <span
            className="px-2 py-0.5 rounded-full text-xs font-semibold"
            style={{ backgroundColor: 'var(--primary)', color: 'var(--primary-foreground)' }}
          >
            Try it free
          </span>
        </div>
        <button
          type="button"
          onClick={() => {
            onAutofill(DEMO_EMAIL, DEMO_PASSWORD);
            toast.success('Demo credentials filled in!');
          }}
          className="text-xs font-bold px-3 py-1.5 rounded-lg transition-all duration-150 active:scale-95"
          style={{ backgroundColor: 'var(--primary)', color: 'var(--primary-foreground)' }}
        >
          Autofill
        </button>
      </div>

      <div className="space-y-2">
        {[
          { label: 'Email', value: DEMO_EMAIL, field: 'email' },
          { label: 'Password', value: DEMO_PASSWORD, field: 'password' },
        ].map((item) => (
          <div key={`demo-cred-${item.field}`} className="flex items-center justify-between gap-3">
            <div className="flex-1 min-w-0">
              <p className="text-xs font-medium mb-0.5" style={{ color: 'var(--muted-foreground)' }}>{item.label}</p>
              <p
                className="text-xs font-mono truncate"
                style={{ color: 'var(--foreground)', fontFamily: 'var(--font-mono)' }}
              >
                {item.field === 'password' ? '••••••••••••' : item.value}
              </p>
            </div>
            <button
              type="button"
              onClick={() => handleCopy(item.value, item.label)}
              className="shrink-0 p-1.5 rounded-lg transition-all duration-150 hover:bg-muted/50"
              style={{ color: 'var(--muted-foreground)' }}
              aria-label={`Copy ${item.label}`}
            >
              <Icon name={copiedField === item.label ? 'CheckIcon' : 'ClipboardDocumentIcon'} size={14} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}